import { Controller } from "stimulus";
import Rails from "@rails/ujs";

// Bloque la soumission du formulaire société quand l'Id externe saisi est déjà
// utilisé par une autre société, et exige une confirmation explicite (confirm natif).
// Contexte : deux sociétés partageant le même Id externe se prennent mutuellement
// leurs salariés à chaque synchronisation (incident Mousseron/STA, juin 2026).
export default class extends Controller {
  static targets = ["field"];
  static values = { url: String, exceptCompanyId: String };

  async submit(event) {
    if (this.confirmed) return;

    const externalId = this.hasFieldTarget ? this.fieldTarget.value.trim() : "";
    if (!externalId) return;

    event.preventDefault();
    const submitter = event.submitter;

    let payload = { in_use: false };
    try {
      const params = new URLSearchParams({ external_id: externalId });
      if (this.exceptCompanyIdValue) {
        params.append("except_company_id", this.exceptCompanyIdValue);
      }
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: { Accept: "application/json" },
      });
      if (response.ok) payload = await response.json();
    } catch (_error) {
      // Si le contrôle échoue (réseau, serveur), on ne bloque pas l'admin :
      // le formulaire part sans confirmation plutôt que de bloquer la saisie.
    }

    if (payload.in_use && !window.confirm(`${payload.message}\n\nVoulez-vous vraiment enregistrer ?`)) {
      // Rails UJS a déjà grisé le bouton (data-disable-with) au moment du clic :
      // sans réactivation, impossible de re-soumettre après une annulation.
      Rails.enableElement(this.element);
      return;
    }

    this.confirmed = true;
    // Réactive le bouton avant la re-soumission : requestSubmit sur un bouton
    // resté grisé par UJS ne repartirait pas proprement.
    Rails.enableElement(this.element);
    if (this.element.requestSubmit) {
      this.element.requestSubmit(submitter);
    } else {
      this.element.submit();
    }
  }
}
